/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const HR_CATEGORIES: SupportCategory[] = [
  { id: 'hr-pto', label: 'PTO', departmentId: 'HR' },
  { id: 'hr-hiring', label: 'Hiring', departmentId: 'HR' },
  { id: 'hr-policies', label: 'Policies', departmentId: 'HR' },
  { id: 'hr-hr-assistance', label: 'HR Assistance', departmentId: 'HR' },
];

export const HR_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'hr-pto-teacher-month', label: 'Teacher Of The Month', categoryId: 'hr-pto' },
  { id: 'hr-pto-approval-correction', label: 'Approval/ Correction', categoryId: 'hr-pto' },
  { id: 'hr-pto-audit', label: 'Audit', categoryId: 'hr-pto' },
  { id: 'hr-hiring-open-positions', label: 'Open Positions', categoryId: 'hr-hiring' },
  { id: 'hr-hiring-assistance', label: 'Hiring Assistance', categoryId: 'hr-hiring' },
  { id: 'hr-hiring-new-hire-paperwork', label: 'New Hire Paperwork', categoryId: 'hr-hiring' },
  { id: 'hr-policies-policies', label: 'Policies', categoryId: 'hr-policies' },
  { id: 'hr-hr-assistance', label: 'HR Assistance', categoryId: 'hr-hr-assistance' },
];

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const HR_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'hr-pto-tom-1',
    subcategoryId: 'hr-pto-teacher-month',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-pto-tom-2',
    subcategoryId: 'hr-pto-teacher-month',
    type: 'text',
    label: `Teacher's First Name`,
    required: true,
  },
  {
    id: 'hr-pto-tom-3',
    subcategoryId: 'hr-pto-teacher-month',
    type: 'text',
    label: `Teacher's Last Name`,
    required: true,
  },
  {
    id: 'hr-pto-tom-4',
    subcategoryId: 'hr-pto-teacher-month',
    type: 'select',
    label: 'Which Month Did They Win TOM?',
    required: true,
    options: MONTHS.map((m) => ({ value: m, label: m })),
  },
  {
    id: 'hr-pto-tom-5',
    subcategoryId: 'hr-pto-teacher-month',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-pto-approval-1',
    subcategoryId: 'hr-pto-approval-correction',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-pto-approval-2',
    subcategoryId: 'hr-pto-approval-correction',
    type: 'text',
    label: `Teacher's First Name`,
    required: true,
  },
  {
    id: 'hr-pto-approval-3',
    subcategoryId: 'hr-pto-approval-correction',
    type: 'text',
    label: `Teacher's Last Name`,
    required: true,
  },
  {
    id: 'hr-pto-approval-4',
    subcategoryId: 'hr-pto-approval-correction',
    type: 'textarea',
    label: 'Reason For Approval / Correction',
    required: true,
  },
  {
    id: 'hr-pto-approval-5',
    subcategoryId: 'hr-pto-approval-correction',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-pto-audit-1',
    subcategoryId: 'hr-pto-audit',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-pto-audit-2',
    subcategoryId: 'hr-pto-audit',
    type: 'text',
    label: `Teacher's First Name`,
    required: true,
  },
  {
    id: 'hr-pto-audit-3',
    subcategoryId: 'hr-pto-audit',
    type: 'text',
    label: `Teacher's Last Name`,
    required: true,
  },
  {
    id: 'hr-pto-audit-4',
    subcategoryId: 'hr-pto-audit',
    type: 'text',
    label: 'Date Range To Audit',
    required: true,
  },
  {
    id: 'hr-pto-audit-5',
    subcategoryId: 'hr-pto-audit',
    type: 'textarea',
    label: 'Reason For Audit',
    required: true,
  },
  {
    id: 'hr-pto-audit-6',
    subcategoryId: 'hr-pto-audit',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-hiring-open-1',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-hiring-open-2',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'select',
    label: 'Position',
    required: true,
    options: [
      { value: 'Lead', label: 'Lead' },
      { value: 'Co-Lead', label: 'Co-Lead' },
      { value: 'Assistant', label: 'Assistant' },
      { value: 'Floater', label: 'Floater' },
      { value: 'STEAM', label: 'STEAM' },
      { value: 'Chef', label: 'Chef' },
      { value: 'Music & Movement', label: 'Music & Movement' },
      { value: 'Nature Exploration', label: 'Nature Exploration' },
      { value: 'Music & Movement and Nature', label: 'Music & Movement and Nature' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    id: 'hr-hiring-open-3',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'select',
    label: 'Age Group',
    required: true,
    options: [
      { value: 'Infants', label: 'Infants' },
      { value: 'Toddlers', label: 'Toddlers' },
      { value: 'Twos', label: 'Twos' },
      { value: 'Threes', label: 'Threes' },
      { value: 'VPK/PreK', label: 'VPK/PreK' },
      { value: 'All', label: 'All' },
    ],
  },
  {
    id: 'hr-hiring-open-4',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'select',
    label: 'Number of posts needed',
    required: true,
    options: [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
    ],
  },
  {
    id: 'hr-hiring-open-5',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'date',
    label: 'When will you like to be posted by?',
    required: true,
  },
  {
    id: 'hr-hiring-open-6',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'select',
    label: 'Was this approved to be sponsored?',
    required: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    id: 'hr-hiring-open-7',
    subcategoryId: 'hr-hiring-open-positions',
    type: 'textarea',
    label: 'Notes, Add any notes you would like HR department to see',
    required: false,
  },
  {
    id: 'hr-hiring-assist-1',
    subcategoryId: 'hr-hiring-assistance',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-hiring-assist-2',
    subcategoryId: 'hr-hiring-assistance',
    type: 'textarea',
    label: 'Reason For Assistance',
    required: true,
  },
  {
    id: 'hr-hiring-assist-3',
    subcategoryId: 'hr-hiring-assistance',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-hiring-paperwork-1',
    subcategoryId: 'hr-hiring-new-hire-paperwork',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-hiring-paperwork-2',
    subcategoryId: 'hr-hiring-new-hire-paperwork',
    type: 'textarea',
    label: 'Issues or help needed with new hire paperwork',
    required: true,
  },
  {
    id: 'hr-hiring-paperwork-3',
    subcategoryId: 'hr-hiring-new-hire-paperwork',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-policies-1',
    subcategoryId: 'hr-policies-policies',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-policies-2',
    subcategoryId: 'hr-policies-policies',
    type: 'textarea',
    label: 'Policy you have questions about',
    required: true,
  },
  {
    id: 'hr-policies-3',
    subcategoryId: 'hr-policies-policies',
    type: 'textarea',
    label: 'Reason',
    required: true,
  },
  {
    id: 'hr-policies-4',
    subcategoryId: 'hr-policies-policies',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'hr-policies-5',
    subcategoryId: 'hr-policies-policies',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-assist-1',
    subcategoryId: 'hr-hr-assistance',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'hr-assist-2',
    subcategoryId: 'hr-hr-assistance',
    type: 'info',
    label: 'HR Assistance or Approval',
    required: false,
    subtitle: `Any requests you need help with....not limited to:
• Arb Transfers and/or others
• Speaking with a staff member
• Leave of Absence Meeting
• Approval for holiday pay, hurricane, etc
• Clarification on policy`,
  },
  {
    id: 'hr-assist-3',
    subcategoryId: 'hr-hr-assistance',
    type: 'select',
    label: 'Choose: HR Assistance or Approval',
    required: true,
    options: [
      { value: 'Assistance', label: 'Assistance' },
      { value: 'Approval', label: 'Approval' },
    ],
  },
  {
    id: 'hr-assist-4',
    subcategoryId: 'hr-hr-assistance',
    type: 'text',
    label: 'Request: HR Assistance or Approval',
    required: true,
    subtitle: 'Name or type of your request. Think email subject and add below in less than 10 words.',
  },
  {
    id: 'hr-assist-5',
    subcategoryId: 'hr-hr-assistance',
    type: 'textarea',
    label: 'Name of Staff Member(s)',
    required: true,
    subtitle:
      `If multiple staff members are involved, list all of their names. ` +
      `If it doesn't relate to any staff member, put n/a`,
  },
  {
    id: 'hr-assist-6',
    subcategoryId: 'hr-hr-assistance',
    type: 'textarea',
    label: 'Reason: HR Assistance or Approval',
    required: true,
    subtitle: 'Tell us the reason why!',
  },
  {
    id: 'hr-assist-7',
    subcategoryId: 'hr-hr-assistance',
    type: 'text',
    label: 'Link: HR Assistance or Approval',
    required: false,
    subtitle: 'Add links to any proof that was shared including documents, pictures, videos, etc',
  },
  {
    id: 'hr-assist-9',
    subcategoryId: 'hr-hr-assistance',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'hr-assist-8',
    subcategoryId: 'hr-hr-assistance',
    type: 'date',
    label: 'Date Needed By: HR Assistance or Approval',
    required: true,
  },
];
